import { INTERVENTIONS_API_URL } from 'constants/InterventionConstants';
import type { DetailedIntervention } from 'modules/interventions/types/projections/detailed-intervention';
import { cleanPayload } from 'utils/RequestUtils';

import * as types from './actionTypes';
import type * as InvoiceType from './types';

export const fetchInvoice: InvoiceType.FetchInvoice = (params, mode, meta = {}) => ({
  type: types.FETCH_INVOICE_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${INTERVENTIONS_API_URL[mode]}/integrations/bezahl-de/search-orders`,
      params: cleanPayload(params)
    }
  },
  meta
});

export const fetchInvoiceSuccess = (invoices: InvoiceType.Invoice[], meta: Record<string, any> = {}): InvoiceType.FetchInvoiceSuccessAction => ({
  type: types.FETCH_INVOICE_SUCCESS,
  payload: invoices,
  meta
});

export const fetchInvoiceFailure = (error: Error, meta: Record<string, any> = {}): InvoiceType.FetchInvoiceFailureAction => ({
  type: types.FETCH_INVOICE_FAILURE,
  payload: error.message,
  error: true,
  meta
});

export const openModal = (interventionId: string, meta: Record<string, any> = {}): InvoiceType.OpenModalAction => ({
  type: types.OPEN_INVOICE_MODAL,
  payload: { interventionId },
  meta
});

export const closeModal = (payload?: any, meta: Record<string, any> = {}): InvoiceType.CloseModalAction => ({
  type: types.CLOSE_INVOICE_MODAL,
  payload,
  meta
});

export const importInvoice: InvoiceType.ImportInvoiceRequest = (interventionId, mode, data, meta = {}) => ({
  type: types.IMPORT_INVOICE_REQUEST,
  payload: {
    request: {
      method: 'POST',
      url: `${INTERVENTIONS_API_URL[mode]}/${interventionId}/integrations/bezahl-de/import-orders`,
      data
    }
  },
  meta
});

export const importInvoiceSuccess = (intervention: DetailedIntervention, meta: Record<string, any> = {}): InvoiceType.ImportInvoiceSuccessAction => ({
  type: types.IMPORT_INVOICE_SUCCESS,
  payload: intervention,
  meta
});

export const importInvoiceFailure = (error: Error, meta: Record<string, any> = {}): InvoiceType.ImportInvoiceFailureAction => ({
  type: types.IMPORT_INVOICE_FAILURE,
  payload: error.message,
  error: true,
  meta
});

export const setInvoiceFilter = (field: string, value: unknown, meta: Record<string, any> = {}): InvoiceType.SetInvoiceFilterAction => ({
  type: types.SET_INVOICE_FILTER,
  payload: { field, value },
  meta
});

export const setInvoiceFilters = (filters: Array<{ field: string; value: unknown }>, meta: Record<string, any> = {}): InvoiceType.SetInvoiceFiltersAction => ({
  type: types.SET_INVOICE_FILTERS,
  payload: filters,
  meta
});

export const removeInvoiceFilter = (field: string, value: unknown, meta: Record<string, any> = {}): InvoiceType.RemoveInvoiceFilterAction => ({
  type: types.REMOVE_INVOICE_FILTER,
  payload: { field, value },
  meta
});

export const clearInvoiceFilters = (payload?: any, meta: Record<string, any> = {}): InvoiceType.ClearInvoiceFiltersAction => ({
  type: types.CLEAR_INVOICE_FILTERS,
  payload,
  meta
});
